import { makeStyles } from '@material-ui/core/styles';
import Colors from '../Colors';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'column',
    margin: '2% 0 2% 0',
    backgroundColor: 'white',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: '90%',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  paperRoot: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '1%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: '5%',
    },
  },
  exportChart: {
    width: '100%',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    margin: '3% 0 5% 0',
  },
  typoTitle: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      alignSelf: 'center',
      marginBottom: '2%',
    },
  },
  buttonExport: {
    border: `1px solid ${Colors.secundary}`,
    fontFamily: 'Roboto',
    color: Colors.main,
    height: '40px',
    width: '100%',
    marginTop: '3%',
    "& span": {
      color: Colors.main,
    },
    '&:hover': {
      border: `1px solid ${Colors.hoverMain}`,
      color: Colors.hoverMain,
      opacity: 0.9,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      fontSize: '12px',
    },
  },
  buttonToPDF: {
    backgroundColor: Colors.secundary,
    fontFamily: 'Roboto',
    color: '#404040',
    height: '40px',
    width: '100%',
    fontWeight: 'bolder',
    justifySelf: 'center',
    '&:hover': {
      backgroundColor: Colors.hoverMain,
      opacity: 0.9,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      fontSize: '12px',
    },
  },
  imgSelect: {
    width: '25p',
    height: '25px',
    marginRight: '10px',
  },
  selectGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginLeft: '-2%',
  },
  itemName: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  containerChart: {
    width: '800px',
    [theme.breakpoints.up('xs')]: {
    },
  },
  containerHeatChart: {
    width: '800px',
    [theme.breakpoints.up('xs')]: {
      height: '270px',
    },
  },
  typo: {
    margin: '5% 0 3% 5%',
    justifySelf: 'center',
  },
  header:{
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    width: "100%",
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paperModal: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${Colors.secundary}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    height: '300px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '24px',
  },
  button: {
    backgroundColor: Colors.secundary,
    color: '#404040',
    '&:hover': {
      backgroundColor: Colors.hoverMain,
    },
  },
}));
